import { Injectable, inject, Component, OnDestroy } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-loading-spinner-overlay',
  standalone: true,
  imports: [MatProgressSpinner],
  template: '<mat-spinner></mat-spinner>'
})
class LoadingSpinnerOverlayComponent {}

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService implements OnDestroy {
  private apiCount = 0;
  private readonly globalSpinner$ = new BehaviorSubject<boolean>(false);
  private overlayRef: OverlayRef | null = null;
  
  private readonly overlay = inject(Overlay);

  readonly loadingSpinner$ = this.globalSpinner$.asObservable();

  private createSpinnerOverlay(): void {
    if (!this.overlayRef) {
      const positionStrategy = this.overlay.position()
        .global()
        .centerHorizontally()
        .centerVertically();

      this.overlayRef = this.overlay.create({
        positionStrategy,
        panelClass: 'spinner-overlay-pane',
        hasBackdrop: true,
        backdropClass: 'spinner-overlay-backdrop'
      });

      const portal = new ComponentPortal(LoadingSpinnerOverlayComponent);
      this.overlayRef.attach(portal);
    }
  }

  private destroySpinnerOverlay(): void {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.overlayRef = null;
    }
  }

  public showSpinner(): void {
    this.apiCount++;
    if (this.apiCount === 1) {
      this.createSpinnerOverlay();
    }
    this.globalSpinner$.next(true);
  }

  public hideSpinner(): void {
    if (this.apiCount > 0) {
      this.apiCount--;
    }
    if (this.apiCount === 0) {
      this.destroySpinnerOverlay();
      this.globalSpinner$.next(false);
    }
  }

  public ngOnDestroy(): void {
    this.globalSpinner$.next(false);
    this.globalSpinner$.complete();
  }
}